import React from 'react'

export default function MyIput(props) {
   return (
      <>
         <input {...props} />
      </>
   )
}
